import type { AuthRole } from "./auth";

export type SessionPerson = {
  given: string;
  family: string;
  email: string;
  role: AuthRole;
};

export type SessionIdentity =
  | { signedIn: false }
  | {
      signedIn: true;
      name: string;
      email: string;
      role: AuthRole;
    };

/** What the header shows for the current login. Signed out stays a text link. */
export function sessionIdentity(account: SessionPerson | null): SessionIdentity {
  if (!account) return { signedIn: false };
  const name = `${account.given} ${account.family}`.replace(/\s+/g, " ").trim();
  return {
    signedIn: true,
    name: name || account.email,
    email: account.email,
    role: account.role,
  };
}
